import { render, staticRenderFns } from "./ItemExportDetails.vue?vue&type=template&id=2dac8b29&"
import script from "./ItemExportDetails.vue?vue&type=script&lang=js&"
export * from "./ItemExportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports